import {Background} from "./Background"
import {Container} from "./Container"
import {TitlesContainer} from "./TitlesContainer"

export const MainPageStyled = {
    Background: Background,
    Container: Container,
    TitlesContainer: TitlesContainer
}
